import 'es6-promise/auto'
import {createApp} from './app'

createApp().then(data => {
    const {app, router} = data;

    router.onReady(() => {
        // actually mount to DOM
        app.$mount('#app');
    });

    // Service worker
    if ('https:' === location.protocol && navigator.serviceWorker) {
        navigator.serviceWorker.register('/service-worker.js')
            .then(() => {
                console.log('Service worker successfully registered.');
            })
            .catch(err => console.log('There is an error registering SW.'))
    }
})